export default "__VITE_ASSET__DYv1yarL__"